import { createContext, useCallback, useContext, useState, type JSX, type ReactNode } from 'react';

interface PageHeaderSlotCtx {
  node: ReactNode | null;
  setSlot: (node: ReactNode | null) => void;
}

const PageHeaderSlotContext = createContext<PageHeaderSlotCtx>({
  node: null,
  setSlot: () => {},
});

export function PageHeaderSlotProvider({ children }: { children: ReactNode }): JSX.Element {
  const [node, setNode] = useState<ReactNode>(null);
  const setSlot = useCallback((n: ReactNode | null) => setNode(n ?? null), []);
  return (
    <PageHeaderSlotContext.Provider value={{ node, setSlot }}>
      {children}
    </PageHeaderSlotContext.Provider>
  );
}

export function usePageHeaderNode(): ReactNode | null {
  return useContext(PageHeaderSlotContext).node;
}

export function usePageHeaderSlot(): (node: ReactNode | null) => void {
  return useContext(PageHeaderSlotContext).setSlot;
}
